<template>
  <div>
    <div class="header-top flex-center">
      <div class="container flex-y-center">
        <div class="flex-grow-1 logo" @click="$router.push({ name: 'Home' })">
          <!-- 首页logo以及学校名-->
          <img src="@/assets/images/logo.png" alt=""/>
        </div>
        <div class="flex-grow-0 flex-row" v-if="!name">
          <div class="header-btn flex-y-center" @click="$router.push({ name: 'Login' })">
            <i class="el-icon-user-solid"></i>
              <span>登录</span>
          </div>
        </div>
          <div class="flex-grow-0 flex-row" v-if="!name">
              <div class="header-btn flex-y-center" @click="$router.push({ name: 'Register' })">
<!--                  <i class="el-icon-user-solid"></i>-->
                  <span>注册</span>
              </div>
          </div>
        <div class="flex-grow-0 flex-row" v-if="!!name">
          <div class="header-btn flex-y-center" @click="$router.push({ name: 'MailList' })">
            <el-badge class="item" :value="readers" :max="99">
              <i class="el-icon-message"></i>
            </el-badge>
          </div>
          <el-dropdown :hide-on-click="true" @command="handleCommand">
            <span class="header-btn flex-y-center">
              <i class="el-icon-user-solid"></i><span>欢迎您，{{ name }}</span>
            </span>
            <el-dropdown-menu>
<!--              <el-dropdown-item command="Account">我的账号</el-dropdown-item>-->
              <el-dropdown-item command="Setpassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="Resume">我的简历</el-dropdown-item>
              <el-dropdown-item command="Collecting">我的收藏</el-dropdown-item>
              <el-dropdown-item command="Apply">我的申请</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div @click="logout" class="header-btn flex-y-center">
            <span>退出</span>
          </div>
        </div>
      </div>
    </div>
    <div class="banner1 container" v-if="isbanner">
      <!--首页背景图-->
      <img src="@/assets/images/banner1.png" alt=""/>
    </div>
    <setpassword ref="setpassword"></setpassword>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import {NAME, SEEKER_INFO} from "@/store/mutation-types"
import Setpassword from "@/views/My/Setpassword"
import {getAction} from "@/api/manage";

export default {
  components: {Setpassword},
  data() {
    return {
      name: '',
      seeker: {},
      readers: 0,
      url: '/letter/unReaders'
    }
  },
  props: {
    isbanner: {
      type: Boolean,
      default: true,
    }
  },
  created() {
    this.name = Vue.ls.get(NAME)
    this.seeker = Vue.ls.get(SEEKER_INFO)
    this.readers = Vue.ls.get('readers')
    this.initData()
  },
  methods: {
    ...mapActions(['Logout']),
    initData() {
      let _this = this
      if (!_this.name) {
        return
      }
      getAction(_this.url, {seekerId: _this.seeker.id}).then(res => {
        if (res.success) {
          _this.$nextTick(() => {
            if (res.result != _this.readers) {
              Vue.ls.set('readers', res.result)
              _this.readers = res.result
            }
          })
        }
      })
    },
    logout() {
      let _this = this
      _this.Logout({}).then((res) => {
        _this.$router.push({name: 'Home'})
      }).catch((err) => {
        _this.$message.error({message: err.message || '请求出现错误，请稍后再试'})
      })
    },
    handleCommand(item) {
      if (item == 'Setpassword') {
        this.$refs.setpassword.show(this.seeker.email, this.seeker.id)
      } else {
        this.$router.push({name: item});
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 注释
.header-btn {
  margin-left: 42px;
  color: #fff;
  cursor: pointer;

  i {
    font-size: 22px;
    margin-right: 2px;
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  line-height: 24px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.banner1 {
  img {
    width: 100%;
  }


}
</style>
